<app-iecook  *ngIf="cookieDisplayed" (manageCookies)="onManageCookies($event)"></app-iecook>
<div class="cgu-iekooc-overlay-shadow" *ngIf="cookieDisplayed"></div>